import { render, staticRenderFns } from "./BuilderHeaderSiteSettings.vue?vue&type=template&id=33191582&scoped=true&"
import script from "./BuilderHeaderSiteSettings.vue?vue&type=script&lang=js&"
export * from "./BuilderHeaderSiteSettings.vue?vue&type=script&lang=js&"
import style0 from "./BuilderHeaderSiteSettings.vue?vue&type=style&index=0&id=33191582&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33191582",
  null
  
)

export default component.exports